import RestService from '../services/rest';

async function getAccessProfiles(limit, skip, search, order = '', field = '') {
  return RestService.getAuthenticated(
    `panel/accessProfiles?limit=${limit}&skip=${skip}&search=${search}&order=${order}&field=${field}`,
  );
}

async function getAccessProfile(id) {
  return RestService.getAuthenticated(`panel/accessProfiles/${id}`);
}

async function getAccessProfileTree(id) {
  return RestService.getAuthenticated(`panel/accessProfiles/tree/${id}`);
}

async function createAccessProfile(accessProfile) {
  return RestService.postAuthenticated('panel/accessProfiles/create', accessProfile);
}

async function updateAccessProfile(accessProfile) {
  return RestService.putAuthenticated('panel/accessProfiles/update', accessProfile);
}

async function deleteAccessProfile(id) {
  return RestService.postAuthenticated('panel/accessProfiles/delete', { id });
}

async function uploadAccessProfile(file, name, id) {
  const fd = new FormData();
  fd.append('file', file);
  return RestService.postAuthenticated(`panel/accessProfiles/import?&name=${name}&id=${id}`,
    fd, {
      'Content-Type': 'multipart/form-data',
    });
}

async function getCsvAccessProfilesReport() {
  const response = await RestService.getAuthenticated('panel/accessProfiles/report/csv', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'accessProfiles-export.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function getCsvAccessProfileModel() {
  const response = await RestService.getAuthenticated('panel/accessProfiles/csv/model', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'Modelo_Importação_AccessProfiles CSV.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function uploadCsvAccessProfiles(file) {
  const fd = new FormData();
  fd.append('file', file);

  return RestService.postAuthenticated('panel/accessProfiles/import/csv', fd, {
    'Content-Type': 'multipart/form-data',
  });
}

export default {
  getAccessProfiles,
  getAccessProfile,
  getAccessProfileTree,
  createAccessProfile,
  updateAccessProfile,
  uploadAccessProfile,
  deleteAccessProfile,
  getCsvAccessProfilesReport,
  getCsvAccessProfileModel,
  uploadCsvAccessProfiles,
};
